import PageSizeSelector from "./PageSizeSelectorComponent";
import {FC} from "react";
import {MdNavigateBefore, MdNavigateNext} from "react-icons/md";
import {useOrganizationsAndParticipantsContext} from "../../providers/OrganizationsAndParticipantsProvider";

const Pagination: FC = () => {
  const {
    setPageNumber,
    pageNumber,
    totalPages,
    pageSize,
    setPageSize,
  } = useOrganizationsAndParticipantsContext()

  return (
    <div className="flex w-full justify-center gap-3 mb-2 flex-wrap">
      <button className="bg-gray-300 rounded-md flex px-3 justify-center items-center"
        onClick={() => setPageNumber(Math.max(pageNumber - 1, 1))}
        disabled={pageNumber === 1}
      >
        <MdNavigateBefore className="size-6" />
      </button>
      <div className="flex justify-self-center items-center gap-2">
        <PageSizeSelector
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
        <span className="h-7 w-[1px] bg-gray-400" />
        <span className="justify-self-center">
          {pageNumber} z {totalPages}
        </span>
      </div>

      <button
        className="bg-gray-300 rounded-md flex px-3 justify-center items-center"
        onClick={() => setPageNumber(Math.min(pageNumber + 1, totalPages))}
        disabled={pageNumber === totalPages}
      >
        <MdNavigateNext className="size-6" />
      </button>
    </div>
  );
};

export default Pagination;
  